import React from 'react';

const StatCard = ({ icon, value, label, color = 'blue' }) => {
  return (
    <div className="stat-card">
      <div className={`stat-icon ${color}`}>{icon}</div>
      <div className="stat-info">
        <div className="stat-value">
          {React.isValidElement(value) ? value : value}
        </div>
        <div className="stat-label">{label}</div>
      </div>
    </div>
  );
};

export default StatCard;
